import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { isNil } from 'lodash';
import SimpleCurrencyInput from './SimpleCurrency';

const renderField = field => (
  <div className="u-position-relative">
    <div className="c-prefix" display-if={field.showPrefix}>%</div>
    <SimpleCurrencyInput
      onInputChange={field.onChange}
      value={field.value}
      className={classnames(field.className, { 'c-input--prepend': field.showPrefix })}
      placeholder={field.placeholder}
      onInputBlur={() => field.input.onBlur(field.input.value)}
      onInputFocus={field.input.onFocus}
      name={field.input.name}
      disabled={field.disabled}
      allowEmpty={field.allowEmpty}
    />
    {
      field.meta.touched && field.meta.error && (
        <div className="c-input-error-message">{field.meta.error}</div>
      )
    }
  </div>
);

const InputComponent = compose(
  withState('updater', 'forceUpdate', false),
  withHandlers({
    onChange: props => (value) => {
      if (String(value).length > 4 && value !== 10000) {
        // SimpleCurrencyInput has its own state which is updated only when outer state is updated
        // since it doesn't provide a way to prevent an event we force an update to set previous value
        props.forceUpdate(!props.updater);
        return;
      }

      if (props.allowEmpty && (isNil(value) || value === '')) {
        props.input.onChange(null);
      } else {
        const formatted = (Number(value) / 100).toFixed(2);
        props.input.onChange(formatted);
      }
    },
  }),
  withProps((props) => {
    if (props.allowEmpty && (isNil(props.input.value) || props.input.value === '')) {
      return { value: null };
    }

    return {
      value: props.input.value ? (Number(props.input.value) * 100).toFixed() : 0,
    };
  }),
)(renderField);

const PercentageInput = props => (
  <Field
    {...props}
    component={InputComponent}
  />
);

PercentageInput.propTypes = {
  name: PropTypes.string.isRequired,
  showPrefix: PropTypes.bool,
};

PercentageInput.defaultProps = {
  showPrefix: true,
};

export default PercentageInput;
